import { render, staticRenderFns } from "./OrganizationalStructure.vue?vue&type=template&id=b6b2fcfa&scoped=true"
import script from "./OrganizationalStructure.vue?vue&type=script&lang=js"
export * from "./OrganizationalStructure.vue?vue&type=script&lang=js"
import style0 from "./OrganizationalStructure.vue?vue&type=style&index=0&id=b6b2fcfa&prod&scoped=true&lang=less"
import style1 from "./OrganizationalStructure.vue?vue&type=style&index=1&id=b6b2fcfa&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b6b2fcfa",
  null
  
)

export default component.exports